import { Root } from 'react-dom/client';
import { AddBizReactLoader } from '../../../Js/React/loader';
import CoursesJourneyList, { CoursesJourney } from '../../../FrontEndReact/src/Core/Components/Journey/CoursesJourneyList';
import JourneySidePanel from '../../../FrontEndReact/src/Core/Components/Journey/JourneySidePanel';
import { getAngularJsService } from '../../../Js/React/Services/legacy';
import { withFrontendContext } from '../../Common/frontendStateContext';

let root: Root | undefined;
AddBizReactLoader(root, 'bizcoursesjourneylist', (e) => {
	const params = (e.detail as { params?: { 
		items?: CoursesJourney[], 
		limit?: number, 
		itemsPerRow?: number,
		hideCollectionFilter?: boolean, 
		hideHeader?: boolean,
		hideFeatured?: boolean,
		noPadding?: boolean
	} }).params;

	const goToJourney = (journey: CoursesJourney) => {
		if (!journey.EngageObjects || journey.EngageObjects.length === 0) return;

		const journeyService = getAngularJsService('bizJourneyService');
		const nextEngageObject = journey.EngageObjects.find((obj) => obj.Status !== 3) ?? journey.EngageObjects[0];
		if (!nextEngageObject) return;

		journeyService.GoToEngageItem(nextEngageObject);
	};

	return withFrontendContext(
		<CoursesJourneyList
			items={params?.items ?? []}
			limit={params?.limit}
			itemsPerRow={params?.itemsPerRow ?? 3} 
			hideCollectionFilter={params?.hideCollectionFilter}
			hideHeader={params?.hideHeader}
			hideFeatured={params?.hideFeatured}
			noPadding={params?.noPadding}
			onJourneyClick={goToJourney}
		/>
	);
});

AddBizReactLoader(root, 'bizjourneysidepanel', (e) => {
	const params = (e.detail as { params?: { item?: { Id?: number; PluginInstanceId?: number; EngageObjectType?: number }; typeName?: string } }).params;
	const journeyService = getAngularJsService('bizJourneyService');
	const goToEngageItemLegacyFn = (item: { Id: number; EngageObjectType: number }) => {
		if (!journeyService || typeof journeyService.GoToEngageItem !== 'function') return;
		journeyService.GoToEngageItem(item);
	};

	return withFrontendContext(
		<JourneySidePanel
			item={params?.item}
			typeName={params?.typeName}
			goToEngageItemLegacyFn={goToEngageItemLegacyFn}
		/>
	);
});
